import { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js'
import 'swiper/swiper.scss'
import { Navigation } from 'swiper'
import Button from '../Templates/Button.js'
import { ReactComponent as Arrow } from '../../../assets/icons/arrow.svg'
import { sendGtag } from '../../utils/utils.js'

// TO DO - the swiper navigation doesn't work on zoomed screens

export default function SwiperComponent({
  slides,
  className = '',
  onSlideChange,
  initialSlideIndex,
  slideEventName,
}) {
  const swiperRef = useRef()
  const [slidesPerGroup, setSlidesPerGroup] = useState(1)

  useEffect(() => {
    if (swiperRef.current && initialSlideIndex) {
      swiperRef.current.swiper.slideTo(initialSlideIndex)
    }
    handleResize()
  }, [swiperRef, initialSlideIndex])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const swiperConfig = {
    className: className || '',
    modules: [Navigation],
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    navigation: false,
    loop: false,
    rewind: true,
    speed: 1000,
    breakpoints: {
      100: {
        slidesPerView: slides.length,
        slidesPerGroup: 0,
        direction: 'vertical',
        spaceBetween: 10,
        freeMode: false,
        allowTouchMove: false,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        direction: 'horizontal',
        freeMode: true,
        allowTouchMove: true,
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1568: {
        slidesPerView: 6,
        slidesPerGroup: 6,
      },
    },
    onSlideChange: onSlideChange,
  }

  const handleResize = () => {
    setSlidesPerGroup(getSlidesPerGroup(window.innerWidth))
  }

  const getSlidesPerGroup = (innerWidth) => {
    if (innerWidth > 1568) {
      return 6
    } else if (innerWidth > 1024) {
      return 4
    } else if (innerWidth > 768) {
      return 3
    }
    return 0
  }

  const next = () => {
    swiperRef.current.swiper.slideNext()

    if (slideEventName) {
      sendGtag(slideEventName)
    }
  }

  const prev = () => {
    swiperRef.current.swiper.slidePrev()

    if (slideEventName) {
      sendGtag(slideEventName)
    }
  }

  return (
    <Swiper
      wrapperClass={slides.length <= slidesPerGroup ? `swiper-overflowed` : ''}
      ref={swiperRef}
      {...swiperConfig}
    >
      {slides.map((cushionComponent, index) => (
        <SwiperSlide key={index}>{cushionComponent}</SwiperSlide>
      ))}
      {(() => {
        if (slides.length > slidesPerGroup) {
          return (
            <>
              <Button className="cp-swiper-btn-prev cp-swiper-btn" onClick={prev}>
                <Arrow currentcolor="fff" height={18} width={22} />
              </Button>
              <Button className="cp-swiper-btn-next cp-swiper-btn" onClick={next}>
                <Arrow currentcolor="fff" height={18} width={22} />
              </Button>
            </>
          )
        }
      })()}
    </Swiper>
  )
}
